import React from "react";
import { Link, useLocation } from "react-router-dom"; 
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/WHPicking" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Picking{" "}
          </span>
        </div>
      ) : vPathName === "/WHPickingDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/WHPicking"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Picking
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Detail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
